<template>
  <sdPageHeader :title="$t('pages.menus.title-detail')"> </sdPageHeader>
  <Main>
    <a-spin :spinning="isLoading">
      <a-card style="margin-bottom: 10px">
        <a-form layout="vertical" :model="data" @submit="update">
          <a-row :gutter="15">
            <a-col :span="12">
              <a-form-item :label="$t('pages.menus.title-tr')">
                <a-input v-model:value="data.title.tr" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="$t('pages.menus.title-en')">
                <a-input v-model:value="data.title.en" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="$t('pages.menus.link')">
                <a-input v-model:value="data.link_name" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="$t('pages.menus.parent-category')">
                <a-select v-model:value="data.parent" style="width: 100%" @change="handleChange">
                  <a-select-option :value="0"> {{ $t('pages.menus.main-category') }}</a-select-option>
                  <a-select-option v-for="menu in menus" :key="menu" :value="menu.id">
                    {{ menu.title[$store.state.i18n.i_lang] }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item>
                <template #label>
                  {{ $t('pages.menus.icon') }}
                  <a href="https://feathericons.com/" target="_blank"
                    >Feather <sdFeatherIcons type="external-link" size="13" />
                  </a>
                </template>
                <a-input v-model:value="data.icon" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item :label="$t('pages.menus.rank')">
                <a-input v-model:value="data.rank" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item :label="$t('pages.menus.status')">
                <a-switch v-model:checked="data.is_active" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-form-item>
            <a-button type="primary" :loading="buttonLoading" html-type="submit"> {{ $t('common.save') }} </a-button>
          </a-form-item>
        </a-form>
      </a-card>
    </a-spin>
  </Main>
</template>

<script>
import { Main } from '@/view/styled';

export default {
  name: 'menuDetail',
  components: {
    Main,
  },
  data() {
    return {
      menu_id: this.$route.params.id,
      isLoading: true,
      buttonLoading: false,
      data: {
        link_name: '',
        parent: 0,
        icon: '',
        rank: '',
        is_active: true,
        title: {
          tr: '',
          en: '',
        },
      },
      menus: [],
    };
  },
  methods: {
    get() {
      this.$appAxios(this.$endpoints.menu_detail_get + '/' + this.menu_id).then((resp) => {
        if (resp.data.status) {
          this.data = resp.data.data;
          this.isLoading = false;
        }else {
          this.$router.push('/');
        }
      });
    },
    getMenus() {
      this.$appAxios.get(this.$endpoints.manu_main_get).then((resp) => {
        this.menus = resp.data.data;
      });
    },
    update() {
      this.buttonLoading = true;
      this.$appAxios.post(this.$endpoints.menu_update + '/' + this.menu_id, this.data).then((resp) => {
        if (resp.data.status) {
          this.$message.success(this.$t('common.success-message'));
        } else {
          this.$message.error(resp.data.message);
        }
        this.buttonLoading = false;
      });
    },
  },
  created() {
    this.get();
    this.getMenus();
  },
};
</script>